export const ClientFieldDefaults = {
    "account_type": "Invidinual"
}